import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ReactComponent as NavigationIcCheck24px } from '../../../../assets/icons/navigation/ic_check_24px.svg';
import { ReactComponent as ContentIcRemove24px } from '../../../../assets/icons/content/ic_remove_24px.svg';

/**
 * @typedef Props
 * @prop {boolean} [selected]
 * @prop {{selected: React.ReactNode, indeterminate: React.ReactNode}} [icons]
 * @prop {boolean} [indeterminate]
 * @prop {() => void} [onClick]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const SelectCheckbox = (props) => {
  const { selected = false, icons = {}, indeterminate = false, onClick = null } = props;
  const classes = classNames({
    'motif-select-checkbox': true,
    'motif-select-checkbox-selected': selected,
    'motif-select-checkbox-indeterminate': indeterminate
  });

  const handleClickCheckBox = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={classes} onClick={handleClickCheckBox}>
      {icons.selected || <NavigationIcCheck24px className="motif-select-checkbox-icon-selected" />}
      {icons.indeterminate || <ContentIcRemove24px className="motif-select-checkbox-icon-indeterminate" />}
    </div>
  );
};

SelectCheckbox.propTypes = {
  selected: PropTypes.bool,
  icons: PropTypes.shape({
    selected: PropTypes.node,
    indeterminate: PropTypes.node
  }),
  indeterminate: PropTypes.bool,
  onClick: PropTypes.func
};

export { SelectCheckbox };
